const HyperSVGLogo = () => (
  <img className="app-bar-logo-img" src="/hyper-logo@2x.png" alt="logo" />
);
export default HyperSVGLogo;
